export const ITEM_STATUS_LIST_MUTATION = "ITEM_STATUS_LIST_MUTATION";
export const ITEM_KEYWORD_LIST_MUTATION = "ITEM_KEYWORD_LIST_MUTATION";
